import React from 'react';
import CommonChart from '../CommonChart';
import {
  getCompetitorBatchRegion,
  getCompetitorBatchCountry,
} from '@/pages/opinion/services';
import { transCountryText, transRegionText } from '@/pages/opinion/utils';
import { useIntl } from 'umi';

export default function RegionCountryChart({
  xAxisList,
  dau,
  commonParams,
  isNoMobile,
}: any) {
  const regionMarketOptions = [
    { value: 'region', text: 'Region' },
    { value: 'market', text: 'Country' },
  ];

  const requestFuncMap = {
    region: getCompetitorBatchRegion,
    market: getCompetitorBatchCountry,
  };

  const selectTitleMap = {
    region: 'Region',
    market: 'Country',
  };
  const { formatMessage } = useIntl();
  const transformFunc = (value: string, type: string) => {
    if (value?.toLocaleUpperCase() === 'GLOBAL') {
      return formatMessage({ id: 'Unidentified -4' });
    }

    if (type === 'region') {
      return transRegionText(value);
    }

    return transCountryText(value);
  };

  return (
    <CommonChart
      xAxisList={xAxisList}
      dau={dau}
      commonParams={commonParams}
      isNoMobile={isNoMobile}
      requestFunc={requestFuncMap}
      firstOptions={regionMarketOptions}
      defaultValue="region"
      selectTitle={selectTitleMap}
      title="Region / Country"
      transformFunc={transformFunc}
    ></CommonChart>
  );
}
